import { CSSProperties, FC, ReactNode } from 'react';
import styles from './InfoBubble.module.css';

export interface BlockAlertProps {
  children: ReactNode;
  icon?: ReactNode;
  styleInfoBubbleOverrides?: CSSProperties;
}

const BlockAlert: FC<BlockAlertProps> = ({
  children,
  styleInfoBubbleOverrides,
  icon,
}) => (
  <div className={styles.infoBubbleContainer} style={styleInfoBubbleOverrides}>
    {icon}
    {children}
  </div>
);

export default BlockAlert;
